import { render, staticRenderFns } from "./utility-transfer-chat-message.vue?vue&type=template&id=4c57233c&"
import script from "./utility-transfer-chat-message.vue?vue&type=script&lang=js&"
export * from "./utility-transfer-chat-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports